import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ApplyCSS from '../../../../../components/ApplyCSS';
import VerificationForm from './verificationForm';
import MultiStepProgressBar from '../../../../../components/MultiStepProgressBar/MultiStepProgressBar';
import OtpCode from './OtpCode';
import DepositForm from './depositForm';
import InputButton from '../../../../../components/ZUILib/InputButton';
import * as typeActions from '../../actions';
import commonUtil from '../../../../../utils/commonUtil';
import * as labelsActions from '../../../../../components/labels/actions';
import StepBar from '../../../../../components/ZUILib/StepBar';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import AppEvents from '../../../../App/AppEvents';
import Tagging from '../../../../../components/Tagging/Tagging';
import AlertTransferences from './alertTransferences';
import { setGiftListTransferenceStatementTab } from '../../../../eventManagement/page/GiftList/actions';

// const d = { isEmployee: 'false', migratedEvent: 'false', links: [], transferenceOptions: { transferableAmount: '1475.00', availableWalletsInfo: [{ accountName: 'Monedero Mesa de Regalos', accountId: '100002', commissionFee: '1.0' }, { accountName: 'Monedero Tarjeta Liverpool', accountId: '100005', commissionFee: '2.0' }, { accountName: 'Monedero Liverpool Premium Card', accountId: '100006', commissionFee: '3.0' }], transferenceMethods: [{ code: '0', name: 'Monedero' }], savedWalletsInfo: [] }, status: { errorMessage: '', errorCode: '', status: 'success' }, currTime: 1529411440965 };
const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const pageName = 'partialTransference';
const pageNameWAP = 'partialTransferenceWAP';
const { getTransferenceOptions, calculateCommision } = typeActions;
const { isLablesLoaded, loadLables } = labelsActions;

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions, setGiftListTransferenceStatementTab })

class RetiroAnticipado extends Component {
  constructor(props) {
    super(props);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.eventOwnerId = this.props.location && this.props.location.state ? this.props.location.state.eventOwnerId : null;
    this.userName = !commonUtil.isObjectEmpty(this.props.user) ? (this.props.user.firstName + ' ' + this.props.user.lastName) : '';
    // this.eventOwnerId = '14900031';
    this.type = 'partial';
    this.userData = null;
    this.pageSendToVarificationForm = null;
    this.paymentType = '';
    this.state = {
      transferenceData: null,
      transferenceDataError: null,
      submitTransferenceData: null,
      depositFormWap: true,
      verificationFormWap: false,
      otpFormWap: false,
      page: 1,
      step: 1,
      info: {
        currentStep: 1,
        total: 3,
      },
    };
  }

  redirectToGiftListPage = () => {
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: this.eventId }));
  }

  UNSAFE_componentWillMount() {
    this.getTransferenceOptions(this.props);
  }
  componentDidMount() {
    commonUtil.clearBrowserHistoryState(commonUtil.getRouteByParameter(applicationRoutes.partialTransference, { eventID: this.eventId }));

    if (this.eventOwnerId) {
      if (channel === constChannels.WAP) {
        this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
        if (this.wapBackButtonEvent) {
          AppEvents.publish(this.wapBackButtonEvent, [() => {
            /*eslint-disable*/
            this.pageSendToVarificationForm === null ? this.redirectToGiftListPage() :
              this.onBackClick();
          }]);
          /*eslint-enable*/
        }
      }
      commonUtil.addTransition();
    } else {
      // If no this.eventOwnerId redirect to Gift List Statement Page
      this.redirectToGiftListPage();
    }

    let url = this.props.route.path.split('(');
    url = url[0] + '/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: url + this.state.info.currentStep,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Retiro anticipado',
      Site: 'Mesa de Regalos',
      idMesa: this.eventId,
    });
  }
  getTransferenceOptions(nextProps) {
    if (!this.userData) {
      this.userData = nextProps.user.status.status === 'success' ? this.props.user : null;
      const activeDigitalWallet = (this.userData.digitalWalletAccNumber !== 'undefined' && this.userData.digitalWalletAccNumber != '' && !_.isEmpty(this.userData.digitalWalletAccNumber)) ? 'true' : 'false';
      if (this.userData && this.eventOwnerId) {
        getTransferenceOptions(this.eventId, this.eventOwnerId, this.type, 'false', activeDigitalWallet)
          .then((res) => {
            if (res.body.status && res.body.status.status === 'success') {
              this.setState({ transferenceData: res.body });
            } else {
              this.setState({ transferenceDataError: res.body.status && res.body.status.errorMessage });
            }
          });
      }
    }
    // this.setState({ transferenceData: d });
  }

  getTodayDate = () => {
    const today = new Date(); 
    const formatted = today.toISOString().split("T")[0];
    return formatted;
  }

  submitTransferenceData = (submitTransferenceParams) => {
    /* eslint-disable */
    let walletType = '';
    if (this.state.transferenceData.isEmployee.toString() === 'true') {
      walletType = '';
    } else {
      if (submitTransferenceParams.walletOrEmployeeIdentifierId) {
        walletType = '0';
      } else {
        walletType = submitTransferenceParams.walletType;
      }
    }
    /* eslint-enable */
    if (submitTransferenceParams.walletType !== undefined) {
      // calculateCommision(this.eventId, '', walletType, submitTransferenceParams.walletOrEmployeeCardAmount, submitTransferenceParams.walletOrEmployeeIdentifierId)
      //   .then((data) => {
      //     if (data.body.status.status === 'success') {
      //       const transactionInfo = data.body.transactionInfo;
      //       if (transactionInfo.commissionToWallet) {
              this.setState({
                submitTransferenceData: {
                  ...submitTransferenceParams,
                  eventId: this.eventId,
                  eventOwnerId: this.eventOwnerId,
                  type: this.type,
                  userName: submitTransferenceParams.userName ? submitTransferenceParams.userName : this.userName,
                  totalAmount: submitTransferenceParams.walletOrEmployeeCardAmount,
                  commissionValue: ".00",
                  transferDate: this.getTodayDate(),
                  walletCommissionAmount: ".00",
                },
              });
              if (channel === constChannels.WAP) {
                this.pageSendToVarificationForm = true;
                if (this.state.info.currentStep === 1) {
                  this.setState({ depositFormWap: false, verificationFormWap: true, otpFormWap: false, info: { currentStep: 2, total: 3 } });
                } else {
                  this.setState({ depositFormWap: false, verificationFormWap: false, otpFormWap: true, info: { currentStep: 3, total: 3 } });
                }
                commonUtil.goToTop();
              } else {
                // this.acc._next(0);
              }
        //     }
        //   }
        // })
        // .catch((e) => {
        //   console.log(e); // console required
        // });
    } else if (submitTransferenceParams.paymentType !== undefined) {
      if (submitTransferenceParams.cardOrBankIdentifierId) {
        this.paymentType = '2';
      } else {
        this.paymentType = submitTransferenceParams.paymentType;
      }
      // calculateCommision(this.eventId, this.paymentType, '', submitTransferenceParams.cardOrBankAmount, submitTransferenceParams.cardOrBankIdentifierId)
      //   .then((data) => {
      //     if (data.body.status.status === 'success') {
      //       const transactionInfo = data.body.transactionInfo;
      //       if (transactionInfo.commissionToCard) {
              this.setState({
                submitTransferenceData: {
                  ...submitTransferenceParams,
                  eventId: this.eventId,
                  eventOwnerId: this.eventOwnerId,
                  type: this.type,
                  userName: submitTransferenceParams.accountName ? submitTransferenceParams.accountName : this.userName,
                  totalAmount: submitTransferenceParams.cardOrBankAmount,
                  commissionValue: ".00",
                  transferDate: this.getTodayDate(),
                  commissionAmount: ".00",
                },
              });
              if (channel === constChannels.WAP) {
                this.pageSendToVarificationForm = true;
                if (this.state.info.currentStep === 1) {
                  this.setState({ depositFormWap: false, verificationFormWap: true, otpFormWap: false, info: { currentStep: 2, total: 3 } });
                } else {
                  this.setState({ depositFormWap: false, verificationFormWap: false, otpFormWap: true, info: { currentStep: 3, total: 3 } });
                }
                commonUtil.goToTop();
              } else {
                // this.acc._next(0);
              }
        //     }
        //   }
        // })
        // .catch((e) => {
        //   console.log(e); // console required
        // });
    }
  }

  onBackClick = () => {
    this.pageSendToVarificationForm = null;
    if (channel === constChannels.WAP) {
      if (this.state.info.currentStep === 3) {
        this.setState({ depositFormWap: false, verificationFormWap: true, otpFormWap: false, info: { currentStep: 2, total: 3 } });
      } else {
        this.setState({ depositFormWap: true, verificationFormWap: false, otpFormWap: false, info: { currentStep: 1, total: 3 } });
      }
      commonUtil.goToTop();
    } else {
      this.nextPage(this.state.page - 1);
    }
  }

  nextPage = (page) => { this.setState({ page }); }

  nextPageWap = () => {
    this.setState({ depositFormWap: false, verificationFormWap: false, otpFormWap: true, info: { currentStep: 3, total: 3 } });
  }

  backPageWap = () => {
    this.setState({ depositFormWap: false, verificationFormWap: true, otpFormWap: false, info: { currentStep: 2, total: 3 } });
  }

  render() {
    const Aceptar = {
      id: 'closeModal',
      type: 'button',
      value: 'Aceptar',
      autoFocus: false,
      style: 'btnPrimary size-Full',
    };
    return (
      <React.Fragment>
        {!_.isEmpty(this.props.lables) ?
          <div className="partialTransference">
            {channel === constChannels.WAP ?
              <div className="row">
                <Tagging ref={tagging => this.tagging = tagging} />
                <ApplyCSS pageName={pageNameWAP} />
                <ModalPopover isModal="true" ref={retire => this.retire = retire} innerClass="popUpHome-content">
                  <div className="p-b-25">
                    <button className="close" id="bgBlack" type="button" data-dismiss="modal" aria-label="Close"><span id="closeModal" aria-hidden="true">×</span></button>
                    <span className="closeText">Cerrar</span>
                  </div>
                  <h4>Retiro anticipado</h4>
                  <p>{commonUtil.getLabel(this.props.lables['Employee- Retiro Anticipado Landing Page'], 'eventTransferences.employee.message1')}</p>
                  {this.state.transferenceDataError ? <div className="alertError" >
                    <i className="icon-tache2" />
                    <p>{this.state.transferenceDataError}</p>
                  </div> : null}
                  <InputButton buttonAttr={Aceptar}><i className="icon-flecha_gruesa_abajo" /></InputButton>
                </ModalPopover>
                <div className="col-xs-12 innerSteps" style={{ padding: 0 }}>
                  <AlertTransferences />
                  <h1
                    className="titleSection"
                    style={{ padding: '0 15px', fontFamily: 'Roboto, sans-serif' }}
                  >
                      Retiro anticipado
                  </h1>
                  <div style={{ padding: '0 15px' }}>
                    <StepBar info={this.state.info} customWidth={'32%'} customStepsCss={' customSteps'} isAddSpacer={true} />
                  </div>

                </div>
                {!_.isEmpty(this.state.transferenceData && this.userData) ?
                  <React.Fragment>
                    <div className={this.state.depositFormWap ? 'display-block' : 'display-none'}>
                      <DepositForm
                        user={this.userData}
                        transference={this.state.transferenceData}
                        submitTransferenceData={this.submitTransferenceData}
                        nextPage={this.nextPage}
                        eventId={this.eventId} lables={this.props.lables} type="partial"
                        setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                      /></div>
                    <div className={this.state.verificationFormWap ? 'display-block' : 'display-none'}>
                      <VerificationForm
                        onBackClick={this.onBackClick}
                        user={this.userData}
                        submitTransferenceData={this.state.submitTransferenceData}
                        eventId={this.eventId} lables={this.props.lables}
                        transferenceData={this.state.transferenceData}
                        nextPageWap={this.nextPageWap} type="partial"
                        isEmployee={this.state.transferenceData.isEmployee}
                        setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                      /></div>
                    <div className={this.state.otpFormWap ? 'display-block' : 'display-none'}>
                      <OtpCode
                        onBackClick={this.onBackClick}
                        user={this.userData}
                        eventId={this.eventId}
                        submitTransferenceData={this.state.submitTransferenceData}
                        lables={this.props.lables}
                        transferenceData={this.state.transferenceData}
                        backPageWap={this.backPageWap}
                        type="partial"
                        isEmployee={this.state.transferenceData.isEmployee}
                        setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                      /></div>
                  </React.Fragment> : null}
              </div>
              : <>
                <div className="adminContainer">
                  <div className="giftBreadcrumbs" />
                </div>
                <Tagging ref={tagging => this.tagging = tagging} />
                <ApplyCSS pageName={pageName} />
                <div>
                  {this.state.transferenceDataError ?
                    <div className="col-xs-12">
                      <div className="alertError" > <i className="icon-tache2" />
                        <p>{this.state.transferenceDataError}</p>
                      </div>
                    </div>
                  : null}
                </div>
                {!_.isEmpty(this.state.transferenceData && this.userData) ?
                  <div className="partialTransferences">
                    <div style={{ width: '93%', margin: '0 4%' }}>
                      <MultiStepProgressBar
                        steps={3}
                        page={this.state.page}
                        stepsLabels={['Forma de depósito', 'Verificación de retiro', 'Verificación de seguridad']}
                      />
                    </div>
                    {
                      // eslint-disable-next-line no-nested-ternary
                      this.state.page === 1 ?
                        <DepositForm
                          user={this.userData}
                          transference={this.state.transferenceData}
                          submitTransferenceData={this.submitTransferenceData}
                          eventId={this.eventId} lables={this.props.lables}
                          nextPage={this.nextPage}
                          type="partial"
                          setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                        /> :
                        // eslint-disable-next-line no-nested-ternary
                        this.state.page === 2 ?
                          <VerificationForm
                            onBackClick={this.onBackClick}
                            user={this.userData}
                            submitTransferenceData={this.state.submitTransferenceData}
                            lables={this.props.lables}
                            transferenceData={this.state.transferenceData}
                            nextPage={this.nextPage}
                            type="partial"
                            isEmployee={this.state.transferenceData.isEmployee}
                            setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                          /> :
                          this.state.page === 3 ?
                            <OtpCode
                              onBackClick={this.onBackClick}
                              user={this.userData}
                              eventId={this.eventId}
                              submitTransferenceData={this.state.submitTransferenceData}
                              lables={this.props.lables}
                              transferenceData={this.state.transferenceData}
                              nextPage={this.nextPage}
                              type="partial"
                              setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                            /> : null
                    }
                  </div>
                  : null}
              </>}
          </div> : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data.result,
  lables: state.labels,
});
const matchDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(RetiroAnticipado);
